<template>
		<div id="pageRoot">

			<p id="text01">
	Pero igual se sigue entrenando.<br><br>

	Don Fito se levanta bien temprano todas las mañanas y lo lleva a revolotear un rato por la Costanera.<br><br>
	—Tenés que aprender a volvar más alto, Venancio! —le explica. Pero no hay caso. A Venancio le gustaba volar bajito. Dice "arf, arf, arf" y le da vueltas y más vueltas a don Fito alrededor de la cabeza.<br><br><br><br>

	Autora: Graciela Montes (Argentina).<br><br>
	<span id="highlight">Venancio vuela bajito</span>, AZ editora.
			</p>

			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
			<div class="pageSVG">
				<img src="/pages/img/sordo/svgPage57.svg" class="pageElement" style=" width: 100%; height: auto;">
			</div>
			<span class="footer-page footer-listen"></span>
			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		</div>
</template>
<style scoped>
#text01
{
position: absolute;
left: 4.98%;
right: 4.98%;
top: 7.68%;
bottom: 13.28%;
margin: 0px;
z-index: 3;

font-family: Open Sans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 22px;
line-height: 26px;

color: #000000;
}

#highlight
{
	font-style: italic;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p53-57/V16.mp4"]
    }
  }
}
</script>